import { useState, useEffect } from 'react';

export interface ProjectCostItem {
  id: string;
  index: string;
  category: string;
  subCategory: string;
  type: string;
  budget: number;
  actual: number;
  paid: number;
  remaining: number;
  percent: number;
  status: string;
  statusColor: string;
  icon: string;
  iconColor: string;
  iconBg: string;
}

export function useProjectCosts() {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setData({
        kpis: [
          { label: 'Tổng ngân sách', value: '28.650.000.000', unit: 'VND', icon: 'ri-wallet-3-line', color: 'text-emerald-500', bg: 'bg-emerald-50' },
          { label: 'Giá trị đã phát sinh', value: '16.850.000.000', unit: 'VND', percent: 58.9, icon: 'ri-money-dollar-box-line', color: 'text-blue-500', bg: 'bg-blue-50' },
          { label: 'Giá trị đã thanh toán', value: '13.250.000.000', unit: 'VND', percent: 46.2, icon: 'ri-bank-card-line', color: 'text-indigo-500', bg: 'bg-indigo-50' },
          { label: 'Giá trị còn lại', value: '11.800.000.000', unit: 'VND', percent: 41.1, icon: 'ri-safe-2-line', color: 'text-rose-500', bg: 'bg-rose-50' },
          { label: 'Dự toán còn lại', value: '11.800.000.000', unit: 'VND', percent: 41.1, icon: 'ri-calculator-line', color: 'text-sky-500', bg: 'bg-sky-50' },
        ],
        costItems: [
          { id: '1', index: '01', category: 'Nhân công', subCategory: 'Chi phí nhân công', type: 'Trực tiếp', budget: 8500000000, actual: 5250000000, paid: 4150000000, remaining: 3250000000, percent: 61.8, status: 'Đang thực hiện', statusColor: 'bg-emerald-50 text-emerald-600', icon: 'ri-group-line', iconColor: 'text-blue-500', iconBg: 'bg-blue-50' },
          { id: '2', index: '02', category: 'Vật tư', subCategory: 'Chi phí vật tư thi công', type: 'Trực tiếp', budget: 7200000000, actual: 4380000000, paid: 3550000000, remaining: 2820000000, percent: 60.8, status: 'Đang thực hiện', statusColor: 'bg-emerald-50 text-emerald-600', icon: 'ri-seedling-line', iconColor: 'text-rose-500', iconBg: 'bg-rose-50' },
          { id: '3', index: '03', category: 'Thiết bị', subCategory: 'Chi phí thiết bị', type: 'Trực tiếp', budget: 3600000000, actual: 2150000000, paid: 1750000000, remaining: 1450000000, percent: 59.7, status: 'Đang thực hiện', statusColor: 'bg-emerald-50 text-emerald-600', icon: 'ri-truck-line', iconColor: 'text-blue-600', iconBg: 'bg-blue-50' },
          { id: '4', index: '04', category: 'Thuê ngoài', subCategory: 'Thuê nhà thầu phụ', type: 'Trực tiếp', budget: 4800000000, actual: 2950000000, paid: 1950000000, remaining: 1850000000, percent: 61.5, status: 'Đang thực hiện', statusColor: 'bg-emerald-50 text-emerald-600', icon: 'ri-user-shared-line', iconColor: 'text-amber-500', iconBg: 'bg-amber-50' },
          { id: '5', index: '05', category: 'Chi phí chung', subCategory: 'Chi phí quản lý dự án', type: 'Gián tiếp', budget: 2250000000, actual: 1250000000, paid: 1050000000, remaining: 1000000000, percent: 55.6, status: 'Đang thực hiện', statusColor: 'bg-emerald-50 text-emerald-600', icon: 'ri-settings-line', iconColor: 'text-emerald-500', iconBg: 'bg-emerald-50' },
        ]
      });
      setIsLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return { data, isLoading };
}
